import Vue from 'vue';
import Vuex from 'vuex';
import { i18n, setI18nLanguage } from '@/i18n'
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const actualidad = {
	state: {
		noticias : '',
		promociones : ''
	},
	getters: {
		categoriaNoticias : (state) => {

			let noticias = state.noticias;

			if(!!noticias){

				let categorias = new Array();

				noticias.forEach( noticia => {
					if(!categorias.some(c => c.slug == noticia.categoria.slug )){
						categorias.push(noticia.categoria)
					}
				});

				return categorias;
			}
		},
		getNoticias : state => state.noticias,
		getPromociones : state => state.promociones,
		getActualidad : state => {
			let data = state.noticias.concat(state.promociones);
			
			// data.sort(function(a, b){

			// 	return true;

			// 	// return new Date(b.fecha.year,b.fecha.month,b.fecha.day).getTime() - new Date(a.fecha.year,a.fecha.month,a.fecha.day).getTime()
			// });

			return data;
		}
	},
	actions: {
		requestNoticias : ({commit},) => {
			return new Promise((resolve, reject) => {
				// Comente siguiente linea para forzar las noticias ES
				/* axios.get(`api/entries/${i18n.locale}/noticias`) */
				axios.get(`api/entries/es/noticias`)
				.then(response => {
					commit('setNoticias', response.data.entries);
					resolve(true);
				})
				.catch(error => reject(error));

			});
		},
		requestNoticia : ({commit}, slug) => {

			return new Promise((resolve, reject) => {

				axios.get(`api/entries/es/noticia/${slug}`)
				.then(response => {
					
					(!!response.data) ? resolve(response.data) : reject(false);
				})
				.catch(err => reject(err));

			});
		},
		requestSimilares : ({},requestdata) => {
			return new Promise((resolve, reject) => {
				axios.get(`api/entries/es/noticias/${requestdata.cat}`)
				.then(response => {
					let noticias = response.data.filter(e => (!!e.imagen_listado.enlace && e.slug != requestdata.id));
					resolve(noticias.slice(0,4));
				})
				.catch(err => reject(error));
			});
		},
		requestPromociones : ({commit},) => {
			return new Promise((resolve, reject) => {
				axios.get(`api/entries/es/promociones`)
				.then(response => {
					commit('setPromociones', response.data.entries);
					resolve(true);
				})
				.catch(error => reject(error));
			});
		},
		requestPromocion : ({commit}, slug) => {

			return new Promise((resolve, reject) => {

				axios.get(`api/entries/es/promocion/${slug}`)
				.then(response => {
					(!!response.data.titulo) ? resolve(response.data) : reject(false);
				})
				.catch(error => reject(error));

			});
		},
	},
	mutations: {
		setNoticias : (state, noticias) => {
			state.noticias = noticias;
		},
		setPromociones : (state, promociones) => {
			state.promociones = promociones;
		}
	}
}

export default actualidad;



// WEBPACK FOOTER //
// ./src/store/actualidad.js